<template>
  <div :class="['bi-button-box', { 'flex-box': showAI }]" :style="fatherStyle">
    <el-button
      :v-zoom="isZoom ? { from: zFormText, name: zNameText } : {}"
      @click.prevent="$emit('click')"
      :disabled="disabled"
      :class="['new-btn', typeClass, hasMinWidth, hasLightHight]"
      :style="btnWidth != '' ? { width: btnWidth } : styleObj"
      :loading="loading"
      :round="round"
    >
      <slot>{{ label }}</slot>
    </el-button>
    <aiToolsBtn v-if="showAI" :sellerId="getSellerId" :sendData="getSendData" />
  </div>
</template>

<script>
import { buriedPointMap } from "@/layOuts/ds/static";

export default {
  name: "bi-button",
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    isPrevent: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "",
    },
    isZoom: {
      type: Boolean,
      default: false,
    },
    // 按钮埋点参数
    zForm: {
      type: String,
      default: "",
    },
    zName: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    /**
     * 按钮类型
     *  default    白色 悬停变灰
     *  break      黑色 悬停变灰黑
     *  blue       蓝色 悬停变浅蓝 （查询按钮）
     *  select     灰色 悬停变蓝色 （已选x个按钮）
     *  toBlue     白色 悬停变蓝
     *  gley       灰色 悬停变黑色字体 （重置按钮）
     *  text       黑色文字 悬停变深黑
     *  blueText   蓝色文字 悬停变浅蓝
     *  labelSelect 灰底 悬停变浅蓝
     *   disabledGrey 灰色 禁用 灰色底
     *   greyText  灰色文字
     */
    type: {
      type: String,
      default: "default",
      // validator: (value) =>
      //   ["default", "break", "blue", "text", "blueText",].includes(value),
    },
    round: {
      // 是否为圆角按钮
      type: Boolean,
      default: false,
    },
    // 按钮宽度
    // tip：传width的时候传styleTextObj是无效的
    /**     
     * 使用例子：
     * <bi-button
          :styleTextObj="{'border-radius': '4px', width: '80px'}"
          >关闭</bi-button
        >
        <bi-button
          width='80px'
          >关闭</bi-button
        >
    **/
    width: {
      type: String,
      default: "",
    },
    fatherStyle: {
      type: [Object, String],
      default: () => {},
    },
    styleTextObj: {
      type: Object,
      default: null,
    },
    // 是否设置最小宽度
    isMinWidth: {
      type: Boolean,
      default: true,
    },
    noAI: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    typeClass() {
      if (this.type != "") {
        return `${this.type}-btn`;
      } else {
        return "default-btn";
      }
    },
    zFormText() {
      return this.zForm ? this.zForm : "";
    },
    zNameText() {
      return this.zName ? this.zName : "";
    },
    hasMinWidth() {
      if (this.type != "text" && this.type != "blueText" && this.isMinWidth) {
        return "min-width";
      } else {
        return "";
      }
    },
    hasLightHight() {
      if (this.type != "text" && this.type != "blueText") {
        return "line-height-box";
      } else {
        return "";
      }
    },
    btnWidth() {
      return this.width;
    },
    styleObj() {
      return this.styleTextObj ? this.styleTextObj : {};
    },
    textDisabled() {
      if ((this.type == "text" || this.type == "blueText") && this.disabled) {
        return "text-disabled";
      } else {
        return "";
      }
    },
    currentObj() {
      const name = this.$route.name;
      const currentObj = buriedPointMap["prefabricateReport"].find(
        (f) => f.path === name
      );
      return currentObj || {};
    },
    showAI() {
      const isAiLabel = this.label == "导出报表" || this.label == "导出数据";
      return isAiLabel && this.currentObj.enumName && !this.noAI;
    },
    getSellerId() {
      if (this.showAI) {
        const platformSellerIds = this.$parent.formData.platformSellerIds;
        if (platformSellerIds && platformSellerIds.length) {
          return Array.isArray(platformSellerIds)
            ? platformSellerIds[0]
            : platformSellerIds;
        } else {
          return "";
        }
      }
    },
    getPayTimeStart() {
      if (this.showAI) {
        if (
          [
            "MEMBER_RECRUIT_JD",
            "MEMBER_RECRUIT_TB",
            // "MEMBER_LEVEL_HYT_ANALYSIS",
            // "POINTS_CHANGE_ANALYSIS",
            // "STORE_SALES"
          ].includes(this.currentObj.enumName)
        ) {
          return this.$parent.formData.startTime
            ? this.$parent.formData.startTime.split(" ")[0]
            : "";
        } else {
          return this.$parent.formData.payTimeStart
            ? this.$parent.formData.payTimeStart.split(" ")[0]
            : "";
        }
      }
    },
    getPayTimeEnd() {
      if (this.showAI) {
        if (
          [
            "MEMBER_RECRUIT_JD",
            "MEMBER_RECRUIT_TB",
            // "MEMBER_LEVEL_HYT_ANALYSIS",
            // "POINTS_CHANGE_ANALYSIS",
            // "STORE_SALES"
          ].includes(this.currentObj.enumName)
        ) {
          return this.$parent.formData.endTime
            ? this.$parent.formData.endTime.split(" ")[0]
            : "";
        } else {
          return this.$parent.formData.payTimeEnd
            ? this.$parent.formData.payTimeEnd.split(" ")[0]
            : "";
        }
      }
    },
    getPayTimeRangeList(){
      if (this.showAI && ["TOP10_PRODUCT_SALES_TAG"].includes(this.currentObj.enumName)) {
        return this.$parent.formData.payTimeRangeList || [];
      }
    },
    getSendData() {
      return [
        {
          name: this.currentObj.name,
          enumName: this.currentObj.enumName,
          payTimeStart: this.getPayTimeStart,
          payTimeEnd: this.getPayTimeEnd,
          payTimeRangeList: this.getPayTimeRangeList,
        },
      ];
    },
  },
};
</script>

<style lang='scss' scoped>
.flex-box {
  display: flex !important;
  align-items: center;
}
.bi-button-box {
  display: inline-block;
  & + & {
    margin-left: 8px;
  }
  .new-btn {
    padding: 0 11px;
    border-radius: 4px;
    font-size: 14px;
    height: auto;
  }
  .break-btn {
    color: #ffffff;
    background: #3159ff;
    border: 1px solid #3159ff;
    border-radius: 4px;
    font-weight: 400px;
    &:hover {
      background: #2b50e6;
      border: 1px solid #2b50e6;
      border-radius: 4px;
    }
    &:focus {
      background: #002dcc;
      border: 1px solid #2768ff;
      border-radius: 4px;
    }
    &.is-disabled {
      color: #ffffff;
      background: #bfbfbf;
      border-radius: 4px;
      border: 1px solid #bfbfbf;
    }
  }
  .default-btn {
    background: #ffffff;
    border: 1px solid #dcdfe6;
    color: #666666;
    &:hover {
      border: 1px solid #f2f3f5;
      color: #666666;
      background: #f2f3f5;
    }
  }
  .blue-btn {
    color: #ffffff;
    background-color: #3159ff;
    border: 1px solid #3159ff;
    &:hover {
      opacity: 0.8;
      color: #ffffff;
      background-color: #3159ff;
      border-color: #3159ff;
    }
    &.is-disabled {
      opacity: 0.5 !important;
      color: #ffffff;
      background-color: #3159ff;
      border-color: #3159ff;
    }
  }
  .blueLine-btn {
    color: #3159ff;
    background-color: #ffffff;
    border: 1px solid #3159ff;
    &:hover {
      opacity: 0.8;
      color: #3159ff;
      background-color: #ffffff;
      border-color: #3159ff;
    }
    &.is-disabled {
      opacity: 0.5 !important;
      color: #3159ff;
      background-color: #ffffff;
      border-color: #3159ff;
    }
  }
  .select-btn {
    background: #f2f3f5;
    color: #666666;
    border: none;
    border: 1px solid #f2f3f5;
    &:hover {
      color: #5286ff;
      background: rgba(39, 104, 255, 0.1);
    }
  }
  .gley-btn {
    color: #333333;
    background-color: #ffffff;
    border: 1px solid #dcdee1;
    &:hover {
      color: #3159ff;
      border: 1px solid #3159ff;
    }
    &.is-disabled {
      opacity: 0.5;
    }
    &.is-disabled:hover {
      color: #333333;
      background-color: #ffffff;
      border: 1px solid #dcdee1;
      opacity: 0.5;
    }
  }
  .text-btn {
    color: #666666;
    border: none;
    padding: 0;
    background: transparent;
    &:hover {
      color: #1f1f1f;
    }
  }
  .blueText-btn {
    color: #3159ff;
    border: none;
    padding: 0;
    background: transparent;
    &:hover {
      opacity: 0.8;
    }
  }
  .labelSelect-btn {
    background: #f5f5f7;
    border: none;
    &:hover {
      background: rgba(39, 104, 255, 0.1);
      color: #2768ff;
      border: none;
    }
  }
  .disabledGrey-btn {
    background: #f2f3f5;
    color: #cccccc;
    border: none;
    // border: 1px solid #f2f3f5;
    &:hover {
      background: #f2f3f5;
      color: #cccccc;
      // border: 1px solid #f2f3f5;
    }
  }
  .greyText-btn {
    background: transparent;
    color: #cccccc;
    border: none;
    // border: 1px solid #f2f3f5;
    &:hover {
      background: transparent;
      color: #cccccc;
      // border: 1px solid #f2f3f5;
    }
  }
  .toBlue-btn {
    background: #f2f3f5;
    border: none;
    &:hover {
      background: rgba(39, 104, 255, 0.1);
      color: #2768ff;
      border: none;
    }
  }
  .min-width {
    min-width: 68px;
  }
  .line-height-box {
    line-height: 30px;
  }
  .text-disabled {
    color: #999999;
    border: none;
    padding: 0;
    background: transparent;
    &:hover {
      color: #999999;
    }
  }
}
</style>